import type { Memo } from '@memori-web/shared';

export interface MemoRowCallbacks {
  onLongPress?: (memo: Memo) => void;
  onSwipeDelete?: (memo: Memo) => void;
}

export function renderMemoRow(root: HTMLElement, memo: Memo, cb: MemoRowCallbacks) {
  if (memo.deletedAt) return;
  const prefix = memo.source === 'pomodoro' ? '🍅 ' : '';
  root.innerHTML = `
    <div class="memo-row" data-id="${memo.id}">
      <span class="memo-row__time">${escapeHtml(memo.timestamp)}</span>
      <span class="memo-row__content">${prefix}${escapeHtml(memo.content)}</span>
    </div>
  `;
  const el = root.querySelector<HTMLDivElement>('.memo-row')!;
  if (cb.onLongPress) attachLongPress(el, () => cb.onLongPress!(memo));
}

function attachLongPress(el: HTMLElement, fn: () => void) {
  let timer: number | null = null;
  const start = () => { timer = window.setTimeout(fn, 500); };
  const cancel = () => { if (timer) { clearTimeout(timer); timer = null; } };
  el.addEventListener('pointerdown', start);
  el.addEventListener('pointerup', cancel);
  el.addEventListener('pointerleave', cancel);
  el.addEventListener('pointercancel', cancel);
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]!));
}
